import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import Box from '@mui/material/Box';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { API_URL } from "src/services/http-service";
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import storageService from "src/services/storage-service";
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import svLocale from "src/locale/sv_SE.json";
import { LocalizationContext } from '@react-pdf-viewer/core';
import { printPlugin } from '@react-pdf-viewer/print';
import core from '@react-pdf-viewer/core';

function AttachmentViewer({ id, token, offsetTop, url }) {

  const printPluginInstance = printPlugin({
    enableShortcuts: false,
    setPages: () => {
      return [1];
    },
  });

  const renderToolbar = (Toolbar) => <Toolbar>
    {(slots) => {
      const {
        CurrentPageInput,
        Download,
        EnterFullScreen,
        GoToNextPage,
        GoToPreviousPage,
        NumberOfPages,
        Print,
        ShowSearchPopover,
        Zoom,
        ZoomIn,
        ZoomOut,
      } = slots;
      return (
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            width: '100%',
          }}
        >
          <div style={{ padding: '0px 2px' }}>
            <ShowSearchPopover />
          </div>
          <div style={{ padding: '0px 2px' }}>
            <GoToPreviousPage />
          </div>
          <div style={{ padding: '0px 2px', width: '4rem' }}>
            <CurrentPageInput />
          </div>
          <div style={{ padding: '0 2px 0 5px' }}>
            / <NumberOfPages />
          </div>
          <div style={{ padding: '0px 2px' }}>
            <GoToNextPage />
          </div>
          <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
            <ZoomOut />
          </div>
          <div style={{ padding: '0px 2px' }}>
            <Zoom />
          </div>
          <div style={{ padding: '0px 2px' }}>
            <ZoomIn />
          </div>

          <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
            <EnterFullScreen />
          </div>
        </div>
      );
    }}
  </Toolbar>;

  const defaultLayoutPluginInstance = defaultLayoutPlugin(
    {
      renderToolbar
    }
  );

  const login = storageService.load();
  const fullUrl = url? url : `${API_URL}/attachment/${id}${token ? '?token=' + token : ''}`;

  return (

    <Box height={`calc(100vh - ${offsetTop}px)`}>
      <LocalizationContext.Provider >
        <Viewer
          defaultScale={1.5}
          localization={svLocale}
          httpHeaders={{ 'accesskey': login.accessKey }}
          plugins={[defaultLayoutPluginInstance, printPluginInstance]}
          fileUrl={fullUrl} />
      </LocalizationContext.Provider>

    </Box>

  )
}

AttachmentViewer.propTypes = {
  id: PropTypes.number,
  token: PropTypes.string,
  offsetTop: PropTypes.number,
  url: PropTypes.string,
}

AttachmentViewer.defaultProps = {
  offsetTop: 180,
  showPrint: false
}

export default AttachmentViewer;